export default __webpack_public_path__ + "static/jUqGmSqN-a2cb82140029e5540e58f5a5cf28264f.svg";